import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import LogoHeader from './partials/LogoHeader';
import Cta from '../sections/Cta';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPhone } from '@fortawesome/free-solid-svg-icons';

const defaultProps = {
  active: false,
  // navPosition: '',
  hideNav: false,
  // hideSignin: false,
  bottomOuterDivider: false,
  bottomDivider: false
};

interface HeaderProps {
  className?: string;
  active?: boolean;
  // navPosition?: string;
  hideNav?: boolean;
  // hideSignin?: boolean;
  bottomOuterDivider?: boolean;
  bottomDivider?: boolean;
}

const Header: FunctionComponent<HeaderProps> = ({
  className,
  active,
  // navPosition,
  hideNav,
  bottomOuterDivider,
  bottomDivider,
  ...props
}) => {
  const [isActive, setIsActive] = useState(false);
  isActive
    ? document.body.classList.add('off-nav-is-active')
    : document.body.classList.remove('off-nav-is-active');
  // const navInput = isActive ? classNames(('px')) : '';
  const nav = useRef<any>(null);
  const hamburger = useRef<any>(null);

  const openMenu = () => {
    nav.current.style.maxHeight = nav.current.scrollHeight + 'px';
    setIsActive(true);
  };

  const closeMenu = () => {
    nav.current && (nav.current.style.maxHeight = null);
    setIsActive(false);
  };

  const keyPress = (e: any) => {
    isActive && e.keyCode === 27 && closeMenu();
  };

  const clickOutside = (e: any) => {
    if (!nav.current) return;
    if (!isActive || nav.current.contains(e.target) || e.target === hamburger.current) return;
    closeMenu();
  };
  const classes = classNames('site-header', bottomOuterDivider && 'has-bottom-divider', className);

  useEffect(() => {
    active && openMenu();
    document.addEventListener('keydown', keyPress);
    document.addEventListener('click', clickOutside);
  }, []);

  useEffect(() => {
    // componentWillUnmount
    return () => {
      document.removeEventListener('keydown', keyPress);
      document.addEventListener('click', clickOutside);
    };
  }, [isActive]);

  return (
    <header {...props} className={classes}>
      <div className="container">
        <div className={classNames('site-header-inner', bottomDivider && 'has-bottom-divider')}>
          <LogoHeader />
          {!hideNav && (
            <React.Fragment>
              <button
                ref={hamburger}
                className="header-nav-toggle"
                onClick={isActive ? closeMenu : openMenu}>
                <span className="screen-reader">Menu</span>
                <span className="hamburger">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
              <nav ref={nav} className={classNames('header-nav px', isActive && 'is-active')}>
                <div className="header-nav-inner">
                  <ul
                    className="list-reset header-nav-right"
                    style={{ gap: '1.5rem', fontSize: '15px', marginRight: '4rem' }}>
                    <li>
                      <Link to="/account-faq" onClick={closeMenu}>
                        Account FAQs
                      </Link>
                    </li>
                    <li>
                      <Link to="/general-faq" onClick={closeMenu}>
                        General FAQs
                      </Link>
                    </li>
                    <li>
                      <Link to="/disclosures" onClick={closeMenu}>
                        Disclosure Library
                      </Link>
                    </li>
                  </ul>
                  <div style={{ marginLeft: '2rem' }}>
                    <Cta buttontext={'Get the app'} split={true} />
                  </div>
                </div>
              </nav>
            </React.Fragment>
          )}
        </div>
      </div>
    </header>
  );
};
Header.defaultProps = defaultProps;
export default Header;
